import { getAgreementType } from '@/types/trades.types';
import type { TradeType } from '@/types/trades.types';

/**
 * Whether the Closing Cash / Closing Settlement figure is shown for a trade.
 *
 * GMRA only (LR-626). The GMSLA figure is `last_marked_price × qty × margin`
 * (`calculate_closing_cash`) — element-wise `marked_contract_value`, which the
 * Economics tab already shows as "Last Marked Margin Value", so it carried no
 * information of its own. The GMRA figure does: contract value plus interest
 * accrued to maturity.
 *
 * Derived from `trade_type`, NOT from the stored `agreement` column: that column
 * carries `default='gmsla'` and only got its create-time guard in LR-617, so a
 * repo booked before it can still be labelled GMSLA — and hiding on a wrong
 * label is the one failure this gate must not have. The entry form has no
 * `agreement` to read at all (LR-634), so deriving is also what keeps the booked
 * trade and the form on one rule.
 *
 * One predicate for every surface so the cell, the clipboard copy,
 * the CSV data cell and the column total cannot drift apart (the doctrine at the
 * head of `settlement-ccy.ts`).
 */
export const showsClosingCash = (t: { trade_type?: TradeType | null }): boolean =>
  t.trade_type != null && getAgreementType(t.trade_type) === 'gmra';
